"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUpload = void 0;
var react_1 = __importStar(require("react"));
var react_dropzone_1 = require("react-dropzone");
var acid_components_1 = require("@michelin/acid-components");
var Icons = __importStar(require("@material-ui/icons"));
var core_1 = require("@material-ui/core");
var hooks_1 = require("../hooks");
exports.FileUpload = function (_a) {
    var bearer = _a.bearer, centralUserProfile = _a.centralUserProfile, onLoad = _a.onLoad, onError = _a.onError, onLoadingChange = _a.onLoadingChange, disabled = _a.disabled, height = _a.height, message = _a.message, _b = _a.disabledMessage, disabledMessage = _b === void 0 ? 'Upload disabled' : _b, application = _a.application, category = _a.category, custom1 = _a.custom1, custom2 = _a.custom2, custom3 = _a.custom3, custom4 = _a.custom4, custom5 = _a.custom5;
    var _c = __read(react_1.useState(false), 2), loading = _c[0], setLoading = _c[1];
    var theme = core_1.useTheme();
    var useUpload = hooks_1.useUploadFiles({
        bearer: bearer,
        centralUserProfile: centralUserProfile,
        application: application,
        category: category,
        custom1: custom1,
        custom2: custom2,
        custom3: custom3,
        custom4: custom4,
        custom5: custom5,
    });
    var handleLoading = react_1.default.useCallback(function (isLoading) {
        setLoading(isLoading);
        if (onLoadingChange)
            onLoadingChange(isLoading);
    }, []);
    var handleUpload = react_1.default.useCallback(function (acceptedFiles) { return __awaiter(void 0, void 0, void 0, function () {
        var promises;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    promises = [];
                    handleLoading(true);
                    return [4 /*yield*/, Promise.all(acceptedFiles.map(function (e) {
                            var p = useUpload.call({
                                file: e,
                                binary: e,
                            });
                            promises.push(p);
                            p.then(function (r) {
                                onLoad(e, r);
                            }).catch(function () { return onError(e); });
                            return p;
                        }))];
                case 1:
                    _a.sent();
                    handleLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var _d = react_dropzone_1.useDropzone({
        onDrop: handleUpload,
    }), getRootProps = _d.getRootProps, getInputProps = _d.getInputProps, isDragActive = _d.isDragActive;
    if (disabled) {
        return (react_1.default.createElement("div", { style: {
                textAlign: 'center',
                backgroundColor: theme.palette.secondary.light,
                height: height,
                padding: 16,
                margin: 16,
                border: 'solid',
                borderWidth: 'thin',
                borderColor: theme.palette.secondary.dark,
            } },
            disabledMessage,
            react_1.default.createElement("br", null),
            react_1.default.createElement(Icons.RemoveCircleOutline, { style: { margin: 16 } })));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", __assign({}, getRootProps()),
            react_1.default.createElement("input", __assign({}, getInputProps())),
            isDragActive ? (react_1.default.createElement("div", { style: {
                    textAlign: 'center',
                    height: height,
                    padding: 16,
                    margin: 16,
                    border: 'solid',
                    borderWidth: 'thin',
                } },
                "Drop the files here ...",
                react_1.default.createElement("br", null),
                react_1.default.createElement(Icons.BackupOutlined, { style: { margin: 16, color: theme.palette.success.dark } }))) : (react_1.default.createElement("div", { style: {
                    textAlign: 'center',
                    // eslint-disable-next-line max-len
                    backgroundImage: "repeating-linear-gradient(45deg, " + theme.palette.background.default + ", " + theme.palette.background.default + " 10px, " + theme.palette.background.paper + " 10px, " + theme.palette.background.paper + " 20px  )",
                    height: height,
                    padding: 16,
                    margin: 16,
                    border: 'solid',
                    borderWidth: 'thin',
                } }, loading ? react_1.default.createElement(acid_components_1.LoadingBounce, null) : (react_1.default.createElement(react_1.default.Fragment, null,
                message,
                react_1.default.createElement("br", null),
                react_1.default.createElement(Icons.BackupOutlined, { style: { margin: 16 } }))))))));
};
//# sourceMappingURL=FileUpload.js.map